/**
 * How long until a query can be refetched when the page is focused on.
 * **5 minutes**
 */
export const DEFAULT_STALE_TIME = 1000 * 60 * 5;

/**
 * How long until a query is garbage collected.
 * **10 minutes**
 */
export const DEFAULT_GC_TIME = 1000 * 60 * 10;